import { apiClient } from "../apiClient";
import type { Coupon } from "./coupon-apis";

export interface CouponUser {
  userid: string;
  coupon: Pick<Coupon, "code" | "numberOfOccurrences">;
  dateCreated: string;
  expiredAT: string;
  numberOfOccurrencesLeft: number;
  status: "ACTIVE" | "INACTIVE";
}

export interface CouponUserListParams {
  couponId: string;
  page?: number;
  search?: string;
  sort?: string;
  filter?: string;
  size?: number;
}

export interface CouponUserListResponse {
  content: CouponUser[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

function buildCouponUserListQuery(params: CouponUserListParams): string {
  const queryParts: string[] = [];

  queryParts.push(`couponId=${params.couponId}`);

  if (params.page !== undefined) {
    queryParts.push(`page=${params.page}`);
  }

  if (params.size !== undefined) {
    queryParts.push(`size=${params.size}`);
  }

  if (params.search) {
    queryParts.push(`search=${encodeURIComponent(params.search)}`);
  }

  if (params.sort) {
    queryParts.push(`sort=${params.sort}`);
  }

  if (params.filter) {
    queryParts.push(params.filter);
  }

  return queryParts.length > 0 ? `?${queryParts.join("&")}` : "";
}

export async function getCouponUsers(
  params: CouponUserListParams
): Promise<CouponUserListResponse> {
  const query = buildCouponUserListQuery(params);
  const response = await apiClient.get<CouponUserListResponse>(
    `/coupon-service/dashboard/user-coupon${query}`
  );
  return response.data;
}
